export default {
  template: {
    label: 'Template Assets',
    describe: 'Customized Creative Templates',
    create: 'Blank Canvas',
    publicVideo: 'Public Video Template',
    publicVideoTitle: 'Create Template Public Video Template',
    production: 'Create Template',
    filter: {
      templateId: 'Template ID',
      state: 'Submission Status',
      unExamine: 'Not Submitted',
      examine: 'Submitted',
      review: 'Rendering',
      reviewFailed: 'Rendering Failed',
      approved: 'Approved',
      refuse: 'Rejected',
      groundStatus: 'Published Status',
      unGround: 'Not Published',
      ground: 'Published',
      grounding: 'Publishing',
      groundFail: 'Failed',
      grounded: 'Not Published',
      replaceMaterial: 'Replacement',
      support: 'Supported',
      unSupport: 'Not supported',
      templateType: 'Template Type',
      commonTemplate: 'Layout Template',
      contentTemplate: 'Creative Template',
      templateLabel: 'Template Tag',
    },
    table: {
      label: 'Template Name and ID',
      size: 'Ratio',
      chineseRules: 'Template Chinese name cannot be empty.',
      enRules: 'Template English name cannot be empty.',
      delete: 'Delete Template',
      deleteLabel: 'Are you sure to delete template " {name} ｜ {name_en} "?',
      unRename: 'Publishing or published templates cannot be renamed.',
      unDelete: 'Publishing or published templates cannot be deleted.',
    },
    dialog: {
      common: 'Multi-proportion',
      content: 'Creative',
    },
  },
}
